<template>
  <div class="asset" ref="assetRef">
    <img :src="image" />
  </div>
</template>

<script>
import {computed, inject, onMounted, ref} from '@vue/composition-api'

import {toPixel} from '@/utils/positioning'
import * as providers from '@world/providers'

export default {
  props: {
    data: {type: Object, required: true},
  },
  setup (props, context) {
    const {
      x,
      y,
      z,
      width,
      imageUrl,
      animation,
      transform,
    } = props.data
    const options = inject(providers.OPTIONS)
    const assetRef = ref()

    onMounted(() => {
      assetRef.value.style.top = toPixel(y)
      assetRef.value.style.left = toPixel(x)
      assetRef.value.style.zIndex = z
      assetRef.value.style.width = toPixel(width)
      assetRef.value.style.transform = transform
      if (animation) {
        assetRef.value.style.animation = animation
      }
    })

    return {
      assetRef,
      image: computed(() => {
        return `${options.assetBaseUrl}${imageUrl}`
      }),
    }
  },
}
</script>

<style scoped lang="scss">
.asset {
  position: absolute;

  img {
    width: 100%;
  }
}
</style>

<style>
@keyframes kiituri {
  0% {
    transform: translateX(0);
    opacity: 1.0;
  }

  5% {
    transform: translateX(-50px);
    opacity: 1.0;
  }

  10% {
    transform: translateX(100vw);
    opacity: 0.0;
  }

  20% {
    transform: translateX(-100vw);
    opacity: 0.0;
  }

  30% {
    transform: translateX(5px);
    opacity: 1.0;
  }

  40% {
    transform: translateX(0);
  }
}

@keyframes clouds {
  0%, 100% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(100%);
  }
}

@keyframes clouds-50p {
  0%, 100% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(50%);
  }
}

@keyframes clouds-20p {
  0%, 100% {
    transform: translateX(0%);
  }
  50% {
    transform: translateX(20%);
  }
}

@keyframes swing {
  0%, 100% {
    transform-origin: 100% 100%;
    transform: rotate(-10deg);
  }
  50% {
    transform-origin: 100% 100%;
    transform: rotate(20deg);
  }
}

@keyframes flag {
  0%, 100% {
    transform-origin: 100% 0%;
    transform: rotateY(180deg);
  }
  50% {
    transform-origin: 100% 0%;
    transform: rotateY(110deg);
  }
}
</style>
